import React from "react";
import {
  PageSection,
  PageSectionBackdrop,
  PageSectionHeader,
  PageSectionHeaderText,
} from "../common";
import { PageHeaderImage } from "../common/PageHeaderImage";

export const FilmPageHeader = ({ filmPage }) => {
  const { heading, body } = filmPage;
  return (
    <PageSection bgColor="var(--creamWhite)">
      <PageSectionBackdrop bgColor="var(--creamWhite)">
        <PageSectionHeader>
          <PageHeaderImage />
          <PageSectionHeaderText>
            <h1>{heading}</h1>
            <p>{body}</p>
          </PageSectionHeaderText>
        </PageSectionHeader>
      </PageSectionBackdrop>
    </PageSection>
  );
};
